import { __awaiter, __generator } from "tslib";
import { createDatePickerDriver } from '../date-picker/driver';
import { DateRangePickerKey } from '.';
export var createDateRangePickerDriver = function (wrapper) {
    var base = wrapper.$("." + DateRangePickerKey);
    var datePicker = createDatePickerDriver(wrapper, DateRangePickerKey);
    return {
        rangeStartDay: function () { return datePicker.selectedDay(0); },
        rangeEndDay: function () { return datePicker.selectedDay(1); },
        selectedMonth: function () { return datePicker.selectedMonth(); },
        selectedYear: function () { return datePicker.selectedYear(); },
        clickDay: function (day) { return datePicker.clickDay(day); },
        clickNextMonth: function () { return datePicker.clickNextMonth(); },
        clickPreviousMonth: function () { return datePicker.clickPreviousMonth(); },
        selectPredefinedRange: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var item, native, event_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = base.$$('.rdr-PredefinedRangesItem').get(idx);
                        return [4 /*yield*/, item.click()];
                    case 1:
                        _a.sent();
                        if (!(base.type === 'react')) return [3 /*break*/, 3];
                        return [4 /*yield*/, item.getNative()];
                    case 2:
                        native = _a.sent();
                        event_1 = document.createEvent('HTMLEvents');
                        event_1.initEvent('click', true, false);
                        native.dispatchEvent(event_1);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        getPredefinedRanges: function () { return base.$$('.rdr-PredefinedRangesItem'); },
        getWeekdays: function () { return base.$$('.rdr-WeekDay').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map